import React, { useContext, useState } from 'react';
import { safeRest } from '@wds/utils';
import { getClientEnvironmentDetails } from '@sm/utils';
import { Accordion } from '@wds/accordion';
import { Responsive } from '@wds/responsive';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { t, defineMessages } from '@sm/intl';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import ProductsMenu from './ProductsMenu';
import HelpMenu from './HelpMenu';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';

const COPY = defineMessages({
  HELP: {
    id: 'InfoMenu.help',
    defaultMessage: 'Help',
    description:
      '[Type: Label][Vis.: high] - This is the Help title of the side menu.',
  },
  PRODUCTS: {
    id: 'InfoMenu.products',
    defaultMessage: 'Products',
    description:
      '[Type: Label][Vis.: high] - This is the Products title of the side menu.',
  },
});

const InfoMenu = ({ ...rest }) => {
  const classes = useStyles();
  const [showProducts, setShowProducts] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const { isDesktop } = getClientEnvironmentDetails();

  const { pageURL, pageURLPath } = useContext(HeaderContext);
  const TrackMenuEvents = (menuName: string, opened: boolean) => {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName: pageURLPath,
        amplitudeEvent: 'header clicked menu',
        menuName,
        opened,
      },
    });
  };

  const toggleProducts = () => {
    setShowHelp(false);
    setShowProducts(!showProducts);
    TrackMenuEvents('product', !showProducts);
  };

  const toggleHelp = () => {
    setShowProducts(false);
    setShowHelp(!showHelp);
    TrackMenuEvents('help center', !showHelp);
  };

  return (
    <>
      <Responsive defaultMatches={!isDesktop} minWidth="xl">
        <>
          <div className={classes.infoMenu} {...safeRest(rest)}>
            <ProductsMenu
              showProducts={showProducts}
              toggleProducts={toggleProducts}
            />
          </div>
          <div className={classes.infoMenu} {...safeRest(rest)}>
            <HelpMenu showHelp={showHelp} toggleHelp={toggleHelp} />
          </div>
        </>
      </Responsive>
      <Responsive defaultMatches={!isDesktop} maxWidth="xl">
        <>
          <Accordion noRules interactive onChange={toggleProducts}>
            <Accordion.Item title={t(COPY.PRODUCTS)}>
              <List noRules interactive transparent>
                <Box className={classes.subNavMenu}>
                  <ProductsMenu
                    showProducts={showProducts}
                    toggleProducts={toggleProducts}
                  />
                </Box>
              </List>
            </Accordion.Item>
          </Accordion>
          <Accordion noRules interactive onChange={toggleHelp}>
            <Accordion.Item title={t(COPY.HELP)}>
              <List noRules interactive transparent>
                <Box className={classes.subNavMenu}>
                  <HelpMenu showHelp={showHelp} toggleHelp={toggleHelp} />
                </Box>
              </List>
            </Accordion.Item>
          </Accordion>
        </>
      </Responsive>
    </>
  );
};

export default InfoMenu;
export { InfoMenu };
